import { render, staticRenderFns } from "./importdata-kolektor.vue?vue&type=template&id=563f3e73&scoped=true&"
import script from "./importdata-kolektor.vue?vue&type=script&lang=js&"
export * from "./importdata-kolektor.vue?vue&type=script&lang=js&"
import style0 from "./importdata-kolektor.vue?vue&type=style&index=0&id=563f3e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f3e73",
  null
  
)

export default component.exports